/* eslint-disable default-param-last */
import {
  SET_TOKEN_RESET_PASSWORD,
  PASSWORD_CHANGED,
} from '../types'

export function setTokenResetPassword(state = '', action) {
  switch (action.type) {
    case SET_TOKEN_RESET_PASSWORD:
      return action.token
    default:
      return state
  }
}

export function passwordChanged(state = false, action) {
  switch (action.type) {
    case PASSWORD_CHANGED:
      return action.data
    default:
      return state
  }
}
